module.exports = __webpack_public_path__ + "static/img/hover1.e7aef394.png";